import React, { useState } from 'react'
import { FormField, TextInput } from './FormField'
import Notifier from './Notifier'
import { authAPI } from '../../utils/api'

export default function ChangePasswordForm() {
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const [notify, setNotify] = useState({ show: false, type: 'info', message: '' })

  const validate = () => {
    const e = {}
    if (!currentPassword) e.currentPassword = 'Current password is required'
    if (!newPassword) e.newPassword = 'New password is required'
    if (!confirmPassword) e.confirmPassword = 'Please confirm the new password'
    if (newPassword && newPassword.length < 8) e.newPassword = 'Password must be at least 8 characters'
    if (newPassword && !/[A-Za-z]/.test(newPassword)) e.newPassword = 'Password must include letters'
    if (newPassword && !/\d/.test(newPassword)) e.newPassword = 'Password must include numbers'
    if (newPassword && confirmPassword && newPassword !== confirmPassword) e.confirmPassword = 'Passwords do not match'
    setErrors(e)
    return Object.keys(e).length === 0
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!validate()) return
    setLoading(true)
    try {
      const message = await authAPI.changePassword({ currentPassword, newPassword, confirmPassword })
      setNotify({ show: true, type: 'success', message: message || 'Password changed successfully' })
      setCurrentPassword('')
      setNewPassword('')
      setConfirmPassword('')
    } catch (err) {
      const msg = err?.response?.data?.message || 'Failed to change password'
      setNotify({ show: true, type: 'error', message: msg })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="max-w-xl">
      <Notifier
        show={notify.show}
        type={notify.type}
        message={notify.message}
        onClose={() => setNotify({ ...notify, show: false })}
      />

      <form onSubmit={handleSubmit} className="space-y-4">
        <FormField label="Current Password" required error={errors.currentPassword}>
          <TextInput
            type="password"
            name="currentPassword"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            placeholder="Enter current password"
            autoComplete="current-password"
          />
        </FormField>

        <FormField label="New Password" required error={errors.newPassword} hint="Minimum 8 characters, include letters and numbers">
          <TextInput
            type="password"
            name="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Enter new password"
            autoComplete="new-password"
          />
        </FormField>

        <FormField label="Confirm New Password" required error={errors.confirmPassword}>
          <TextInput
            type="password"
            name="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Re-enter new password"
            autoComplete="new-password"
          />
        </FormField>

        <div className="pt-2">
          <button
            type="submit"
            disabled={loading}
            className={`inline-flex items-center px-4 py-2 rounded-md shadow-sm text-white ${loading ? 'bg-secondary-400' : 'bg-primary hover:bg-primary-600'} transition-colors duration-150`}
          >
            {loading ? 'Updating…' : 'Change Password'}
          </button>
        </div>
      </form>
    </div>
  )
}